/* eslint-disable no-unused-vars */
"use server";

interface CookieOptions {
  expires?: Date;
  maxAge?: number;
  domain?: string;
  path?: string;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: boolean | "lax" | "strict" | "none";
  priority?: "low" | "medium" | "high";
  encode?: (value: string) => string;
  partitioned?: boolean;
}

import { cookies } from "next/headers";

export async function setCookie(
  key: string,
  value: string,
  options: CookieOptions
) {
  cookies().set(key, value, {
    ...options,
    httpOnly: options.httpOnly ?? true
  });
  return { definido: true, key, value };
}
